// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._favoritesList_1f0eg_1 {
  height: 100%;
  width: 100%;
}
._favoritesList__buttonCol_1f0eg_5 {
  margin-top: var(--perxis-auto-gap-vertical-yellow-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
